import { clientsConstants } from "../constants/action.constants";
import { clientService } from "../services/clients.service";
import { alertActions } from "../../Alert/actions/alert.actions";
import { message, routeConstants } from "../../../_constants";
import { history } from "../../../_utils";

export const clientActions = {
  addClient,
  getAllClients,
  getClient,
  resetClient,
  resetAddClient
};

function getAllClients() {
  return async dispatch => {
    dispatch(request());
    try {
      const response = await clientService.getAllClients();
      response && dispatch(success(response));
    } catch (error) {
      dispatch(failure(error));
      dispatch(
        alertActions.error(
          error ? error.message : message.GENERIC_ERROR,
          message.LOAD_CLIENTS
        )
      );
    }
  };

  function request() {
    return { type: clientsConstants.GET_CLIENTS_REQUEST };
  }
  function success(response) {
    return { type: clientsConstants.GET_CLIENTS_SUCCESS, response };
  }
  function failure(error) {
    return { type: clientsConstants.GET_CLIENTS_FAILURE, error };
  }
}

function getClient(id) {
  return async dispatch => {
    dispatch(request(id));
    try {
      const response = await clientService.getClient(id);
      response && dispatch(success(response));
    } catch (error) {
      dispatch(failure(error));
      dispatch(
        alertActions.error(
          error ? error.message : message.GENERIC_ERROR,
          `${message.GET_CLIENT}: ${id}`
        )
      );
    }
  };

  function request(id) {
    return { type: clientsConstants.VIEW_CLIENT_REQUEST, id };
  }
  function success(response) {
    return { type: clientsConstants.VIEW_CLIENT_SUCCESS, response };
  }
  function failure(error) {
    return { type: clientsConstants.VIEW_CLIENT_FAILURE, error };
  }
}

function addClient(requestBody) {
  return async dispatch => {
    dispatch(request(requestBody));
    try {
      const response = await clientService.addClient(requestBody);
      response && dispatch(success(response));
      if(requestBody.id) {
        history.push(routeConstants.CLIENTS.path);
      }
      dispatch(getAllClients());
      dispatch(
        alertActions.success(
          response && response.responseMessage,
          requestBody.id ? message.EDIT_CLIENT : message.ADD_CLIENT
        )
      );
      dispatch(resetAddClient());
      dispatch(resetClient());
    } catch (error) {
      dispatch(failure(error));
      dispatch(
        alertActions.error(
          error ? error.message : message.GENERIC_ERROR,
          requestBody.id ? message.EDIT_CLIENT : message.ADD_CLIENT
        )
      );
    }
  };

  function request(requestBody) {
    return { type: clientsConstants.ADD_CLIENT_REQUEST, requestBody };
  }
  function success(response) {
    return { type: clientsConstants.ADD_CLIENT_SUCCESS, response };
  }
  function failure(error) {
    return { type: clientsConstants.ADD_CLIENT_FAILURE, error };
  }
}

function resetClient() {
  return { type: clientsConstants.VIEW_CLIENT_RESET };
}

function resetAddClient() {
  return { type: clientsConstants.ADD_CLIENT_RESET };
}
